export const INCREMENT_COUNT = "INCREMENT_COUNT";
export const SET_USER_LOGIN = "SET_USER_LOGIN";
export const SET_USER_LOGOUT = "SET_USER_LOGOUT";
